export default __webpack_public_path__ + "static/media/connected by qrcode.1d0dce98.svg";